module.exports = __webpack_public_path__ + "02_bob_brown.edf7b78e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/02_bob_brown.png
// module id = bAsp
// module chunks = 0